var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-status",class:[_vm.status, _vm.size]},[_vm._v(" "+_vm._s(_vm._f("capitalizeAll")(_vm.status))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }